<template>
  <div>
    Please wait...
  </div>
</template>

<script>
export default {
  name: 'Callback',
  props: {
    onCompleteCallback: {
      type: Function,
      required: false,
      default: null,
    },
    successRoute: {
      type: Object,
      required: true,
    },
    errorRoute: {
      type: Object,
      required: true,
    },
    newUserRoute: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    console.log('callback mounted')
    this.$store.dispatch('auth/handleAuthentication').then((data) => {
      // alert('pause')
      if (data) {
        console.log('handling auth...')
        if (data.profile) {
          // We have an Auth0 profile
          this.$store.dispatch('user/getProfile', this.onCompleteCallback).then(
            (response) => {
              if (response && response.entity) {
                // we have a valid chirhos profile
                let _returnUrl = JSON.parse(
                  window.localStorage.getItem('returnUrl')
                )

                if (_returnUrl && _returnUrl !== '') {
                  window.localStorage.setItem('returnUrl', JSON.stringify(''))
                  this.$router.push({
                    name: _returnUrl.name,
                    params: _returnUrl.params,
                  })
                } else {
                  this.$router.push(this.successRoute)
                }
              } else {
                // we don't have a valid chirhos profile so redirect to new user route
                this.$router.push(this.newUserRoute)
              }
            },
            (error) => {
              console.error(error)
              this.$router.push(this.errorRoute)
            }
          )
        } else {
          this.$router.push(this.errorRoute)
          // this.$router.push(this.signupRoute)
        }
      } else {
        console.log('no data on auth')

        // console.log('Redirecting to dashbaord (2)')
        // This user does not have access -> Redirect to 401 'Access Denied' page or back to login
        this.$router.push(this.errorRoute) // Dashboard requires a valid user so will ask user to log in again
      }
    })
  }
}
</script>
